// MUSS als Erstes laufen: patcht ResizeObserver + unterdrueckt benignes
// "ResizeObserver loop"-Fehler-Overlay (blockierte u. a. das Delegations-Modal).
import "@/lib/resizeObserverErrorHandler";
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { bootstrapThemeFromCache } from "@/pages/theme/themeConstants";

// Bug #2 Fix: Theme aus Cache VOR React-Mount applizieren (verhindert FOUC)
bootstrapThemeFromCache();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
